import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { App } from './App';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import BranchUsers from './pages/BranchUsers';
import BulkUpload from './pages/BulkUpload';
import BulkUploadLists from './pages/BulkUploadLists';
import Partners from './pages/Partners';
import PartnerUsers from './pages/PartnerUsers';
import SubAgents from './pages/SubAgents';
import SubAgentUsers from './pages/SubAgentUsers';
import TransactionView from './pages/TransactionView';
import EnhancedTransactions from './pages/EnhancedTransactions';
import FailedTransactions from './pages/FailedTransactions';
import FailedTabs from './pages/FailedTabs';
import RTGSTransactions from './pages/RTGSTransactions';
import TransactionReversal from './pages/TransactionReversal';
import ComplianceReview from './pages/ComplianceReview';
import ComplianceCaseManagement from './pages/ComplianceCaseManagement';
import FundingSettlement from './pages/FundingSettlement';
import CorridorGovernance from './pages/CorridorGovernance';
import FXManagement from './pages/FXManagement';
import ReportingExports from './pages/ReportingExports';
import MakerInbox from './pages/MakerInbox';
import CheckerInbox from './pages/CheckerInbox';
import CheckerInboxCancellation from './pages/CheckerInboxCancellation';
import CheckerInboxAmendment from './pages/CheckerInboxAmendment';
import CheckerManualSettlement from './pages/CheckerManualSettlement';
import MakerManualSettlement from './pages/MakerManualSettlement';
import EPRCGeneration from './pages/EPRCGeneration';
import ReversalLists from './pages/ReversalLists';
export function AppRouter({
  isLoggedIn,
  onLogout,
  onLogin
}) {
  const userRole = localStorage.getItem('userRole') || 'maker';
  const isChecker = userRole === 'checker';
  return <>
      {isLoggedIn ? <Routes data-id="element-6">
          <Route path="/" element={<Dashboard onLogout={onLogout} data-id="element-8" />} data-id="element-7" />
          <Route path="/transactions" element={<TransactionView onLogout={onLogout} data-id="element-10" />} data-id="element-9" />
          <Route path="/enhanced-transactions" element={<EnhancedTransactions onLogout={onLogout} data-id="element-12" />} data-id="element-11" />
          <Route path="/checker-inbox-amendment" element={<CheckerInboxAmendment onLogout={onLogout} data-id="element-14" />} data-id="element-13" />

          {/* Maker-only routes */}
          {!isChecker && <>
              <Route path="/failed-transactions" element={<FailedTransactions onLogout={onLogout} data-id="element-16" />} data-id="element-15" />
              <Route path="/failed-tabs" element={<FailedTabs onLogout={onLogout} data-id="element-18" />} data-id="element-17" />
              <Route path="/rtgs" element={<RTGSTransactions onLogout={onLogout} data-id="element-20" />} data-id="element-19" />
              <Route path="/transaction-reversal" element={<TransactionReversal onLogout={onLogout} data-id="element-22" />} data-id="element-21" />
              <Route path="/eprc-generation" element={<EPRCGeneration onLogout={onLogout} data-id="element-24" />} data-id="element-23" />
              <Route path="/compliance" element={<ComplianceReview onLogout={onLogout} data-id="element-26" />} data-id="element-25" />
              <Route path="/compliance-cases" element={<ComplianceCaseManagement onLogout={onLogout} data-id="element-28" />} data-id="element-27" />
              <Route path="/funding-settlement" element={<FundingSettlement onLogout={onLogout} data-id="element-30" />} data-id="element-29" />
              <Route path="/corridor-governance" element={<CorridorGovernance onLogout={onLogout} data-id="element-32" />} data-id="element-31" />
              <Route path="/fx-management" element={<FXManagement onLogout={onLogout} data-id="element-34" />} data-id="element-33" />
              <Route path="/reporting-exports" element={<ReportingExports onLogout={onLogout} data-id="element-36" />} data-id="element-35" />
              <Route path="/branch-users/user-management" element={<BranchUsers onLogout={onLogout} data-id="element-38" />} data-id="element-37" />
              <Route path="/branch-users/maker-inbox" element={<MakerInbox onLogout={onLogout} data-id="element-40" />} data-id="element-39" />
              <Route path="/branch-users/checker-inbox" element={<CheckerInbox onLogout={onLogout} data-id="element-42" />} data-id="element-41" />
              <Route path="/checker-inbox-cancellation" element={<CheckerInboxCancellation onLogout={onLogout} data-id="element-44" />} data-id="element-43" />
              <Route path="/checker-manual-settlement" element={<CheckerManualSettlement onLogout={onLogout} data-id="element-46" />} data-id="element-45" />
              <Route path="/maker-manual-settlement" element={<MakerManualSettlement onLogout={onLogout} data-id="element-48" />} data-id="element-47" />
              <Route path="/branch-users/bulk-upload" element={<BulkUpload onLogout={onLogout} data-id="element-50" />} data-id="element-49" />
              <Route path="/branch-users/bulk-upload/lists" element={<BulkUploadLists onLogout={onLogout} data-id="element-52" />} data-id="element-51" />
              <Route path="/partners" element={<Partners onLogout={onLogout} data-id="element-54" />} data-id="element-53" />
              <Route path="/partner-users" element={<PartnerUsers onLogout={onLogout} data-id="element-56" />} data-id="element-55" />
              <Route path="/sub-agents" element={<SubAgents onLogout={onLogout} data-id="element-58" />} data-id="element-57" />
              <Route path="/sub-agent-users" element={<SubAgentUsers onLogout={onLogout} data-id="element-60" />} data-id="element-59" />

              <Route path="/reversal-lists" element={<ReversalLists onLogout={onLogout} data-id="element-62" />} data-id="element-61" />
            </>}

          <Route path="*" element={<Navigate to="/" data-id="element-64" />} data-id="element-63" />
        </Routes> : <Routes data-id="element-65">
          <Route path="*" element={<Login onLogin={onLogin} data-id="element-67" />} data-id="element-66" />
        </Routes>}
    </>;
}